import React from 'react'
import { fmt, arrayFrom, hideModal, showBondOrder, parseDate, sortFn } from '../twd'
import { useTreasuryAuctions } from './use-treasury-auctions'

export default () => {
    const { auctions } = useTreasuryAuctions()
    const hasAuctions = auctions.length > 0

    return <React.Fragment>
    <div className="row vertical-offset-xs"></div>

    { !hasAuctions && <EmptyMsg />}

    { hasAuctions && <Table /> }


    </React.Fragment>
}

const EmptyMsg  = () =>
    <div className="col-md-12 text-center">
    <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
    <div className="small-header">There are currently no live Treasury auctions.</div>
    <p>Check the upcoming auctions table for the tentative schedule.</p>
    </div>

const monthsDaysFromToday = (s) => {
    const d = parseDate(s)
    if (!d || isNaN(d)) return null
    const n = new Date()
    if (n>d) return null

    const dy = d.getFullYear() - n.getFullYear()
    const dm = d.getMonth() - n.getMonth()

    const dd = d.getDate() - n.getDate()
    const isLess = dd < 0

    const months = dy * 12 + dm + (isLess ?  - 1 : 0)
    n.setMonth(n.getMonth() + months)

    let days = !isLess
        ? dd
        : Math.floor(Math.abs(d-n) / (24 * 60 * 60 * 1000))

    return { months, days}
}

const fmtTimes = (n, l) => (n ? `${n} ${l}${n>1 ? 's': ''}` : '')

const Table = () => {
    const { auctions } = useTreasuryAuctions()

    return <React.Fragment>
    <div className="row">
    <div className="col-xs-12 table-responsive">
        <table className="table auctions-table">
        <thead>
            <tr>
            <th>Issue</th>
            <th className="text-right">CUSIP</th>
            <th className="text-right">Auction date</th>
            <th className="text-right">Maturity date</th>
            <th className="text-right">Min Qty<br/>(,000)</th>
            <th className="text-right">Max Qty^<br/>(,000)</th>
            <th className="text-right">Auction close</th>
            <th className="text-right">Settlement date</th>
            <th className="text-right">Indicative yield†</th>
            <th className="text-center">Action</th>
            </tr>
        </thead>
        <tbody>
            { arrayFrom(auctions)
                .sort(sortFn(({maturity}) => {
                    return fmt.fmtDt(parseDate(maturity), 'yyyy-MM-dd')
                }))
                .map((r,i) => {
                    const { issue, cusip, auctionDate, maturity, minQty, maxQty, auctionCloseText, settlement, ctfYield} = r

                    const a = monthsDaysFromToday(maturity)
                    const matSubText = !a
                        ? ''
                        : [fmtTimes(a.months, 'month'), fmtTimes(a.days, 'day')].filter(Boolean).join(', ') + ' from today'

                    return <tr key={i}>
                        <td>{issue}</td>
                        <td className="text-right">{cusip}</td>
                        <td className="text-right">{fmt.mdy(auctionDate)}</td>
                        <td className="text-right">{fmt.mdy(maturity)}<div className='text-muted'>{matSubText}</div></td>
                        <td className="text-right">{fmt.qty(minQty)}</td>
                        <td className="text-right">{fmt.qty(maxQty)}</td>
                        <td className="text-right" dangerouslySetInnerHTML={{__html:auctionCloseText.replace(', ','<br/>')}}></td>
                        <td className="text-right">{fmt.mdy(settlement)}</td>
                        <td className="text-right">{fmt.ytw3(ctfYield)}</td>
                        <td className="text-center"><button className='btn btn-primary'
                            onClick={() => {
                                hideModal()
                                showBondOrder({
                                    action:'B',
                                    cusip,
                                    isTreasuryAuction: true,
                                    settlement,
                                    from: 'treasury-auctions',
                                    ts: Date.now(),
                                })
                            }}
                        >Buy</button></td>
                    </tr>
                })
            }
        </tbody>
        </table>
    </div>
    </div>
    </React.Fragment>
}